/**
 * EnviarEmailDialog — envia e-mail ao contato do lead (assunto + corpo).
 *
 * Exige contato_email (backend retorna 400 se vazio — tratamos inline). O
 * reply-to vai no nome do vendedor (backend cuida). Pode pre-preencher o
 * corpo com contexto SPIN via `sugestao`.
 */
import React, { useEffect, useState } from "react";
import { FiAlertCircle, FiMail } from "react-icons/fi";

import AsyncButton from "../../../components/AsyncButton";
import SlideOverPanel from "../../../components/SlideOverPanel";
import {
  Field,
  FormStack,
  InlineHint,
  Input,
  Textarea,
} from "../styles";
import { WarningMsg } from "../../Orcamentos/styles";

function EnviarEmailDialog({ open, onClose, onEnviar, email, sugestao }) {
  const [assunto, setAssunto] = useState("");
  const [corpo, setCorpo] = useState("");
  const [aviso, setAviso] = useState(null);

  useEffect(() => {
    if (open) {
      setAssunto("");
      setCorpo(sugestao || "");
      setAviso(null);
    }
  }, [open, sugestao]);

  const fechar = () => {
    setAssunto("");
    setCorpo("");
    setAviso(null);
    onClose();
  };

  const enviar = async () => {
    setAviso(null);
    if (!assunto.trim()) {
      setAviso("Informe o assunto.");
      throw new Error("Assunto obrigatório.");
    }
    if (!corpo.trim()) {
      setAviso("Escreva o corpo do e-mail.");
      throw new Error("Corpo obrigatório.");
    }
    try {
      await onEnviar({ assunto: assunto.trim(), corpo: corpo.trim() });
      fechar();
    } catch (err) {
      setAviso(err?.message || "Não foi possível enviar o e-mail.");
      throw err;
    }
  };

  return (
    <SlideOverPanel
      open={open}
      onClose={fechar}
      title="Enviar e-mail"
      subtitle={email ? `Para ${email}` : "Lead sem e-mail cadastrado"}
      width="min(95vw, 520px)"
      footer={
        <>
          <button type="button" className="btn btn--secondary" onClick={fechar}>
            Cancelar
          </button>
          <AsyncButton onClick={enviar} silentSuccess silentError>
            <FiMail size={14} aria-hidden="true" /> Enviar
          </AsyncButton>
        </>
      }
    >
      <FormStack>
        {!email && (
          <WarningMsg>
            <FiAlertCircle size={14} aria-hidden="true" />
            Este lead não tem e-mail. Cadastre o e-mail do contato em
            &quot;Dados do lead&quot; antes de enviar.
          </WarningMsg>
        )}
        <Field>
          Assunto
          <Input
            type="text"
            value={assunto}
            onChange={(e) => setAssunto(e.target.value)}
            placeholder="Ex: Sua proposta de cozinha planejada"
            maxLength={200}
            autoFocus
          />
        </Field>
        <Field>
          Mensagem
          <Textarea
            value={corpo}
            onChange={(e) => setCorpo(e.target.value)}
            rows={8}
            placeholder="Escreva o corpo do e-mail..."
          />
          <InlineHint>
            O e-mail sai pela empresa com resposta direcionada a você. Fica
            registrado na timeline do lead.
          </InlineHint>
        </Field>
        {aviso && (
          <WarningMsg>
            <FiAlertCircle size={14} aria-hidden="true" /> {aviso}
          </WarningMsg>
        )}
      </FormStack>
    </SlideOverPanel>
  );
}

export default EnviarEmailDialog;
